<template>
  <Modal
    class="participantModal"
    :isOpen="isOpen"
    :buttons="{
      column: false,
      data: [
        {
          label: 'Retourner à ma campagne',
          class: 'secondary',
        },
        {
          label: 'Enregistrer les modifications',
          class: 'green',
          disabled: state.user_comment === currentParticipant.user_comment,
        },
      ],
    }"
    title="Informations talent"
    @close="close()"
    @callbackBtn1="close()"
    @callbackBtn2="saveNote()"
  >
    <template #extra>
      <span
        class="participant-name"
        v-if="currentParticipant.candidate_id"
        v-html="
          `${currentParticipant.candidate.first_name} ${currentParticipant.candidate.last_name}`
        "
      />
      <span
        class="participant-name"
        v-else
        v-html="
          currentParticipant.pending_first_name &&
          currentParticipant.pending_last_name
            ? `${currentParticipant.pending_first_name} ${currentParticipant.pending_last_name}`
            : '<p class=\'muted\'>Non renseigné</p>'
        "
      />
      <div class="activities">
        <div class="container">
          <div class="activity-title">Date d'ajout à la campagne</div>
          <p
            v-text="
              getDate(currentParticipant.creation_time, 'D MMM YYYY à HH[h]mm')
            "
          />
        </div>
        <div class="container">
          <div class="activity-title">Date de création du compte</div>
          <p
            v-text="
              currentParticipant.candidate
                ? getDate(
                    currentParticipant.candidate?.creation_time,
                    'D MMM YYYY à HH[h]mm'
                  )
                : 'Compte non créé'
            "
          />
        </div>
      </div>
      <div class="input-inline">
        <InputCopy
          :label="$t('form.email')"
          :value="
            currentParticipant.candidate?.email ||
            currentParticipant.pending_email
          "
        />        
        <InputCopy
          :label="$t('form.register.phone')"
          :value="
            currentParticipant.candidate?.phone_number ||
            'Non renseigné'
          "
        />
      </div>
      <TabsNavigation
        :tabs="['Notes sur le talent', 'État de l\'évaluation']"
        @changeTab="(value) => (state.currentTab = value)"
      />
      <transition mode="out-in" name="fade">
        <component
          :is="tabsContent[state.currentTab]"
          :participant="currentParticipant"
          :notes="state.user_comment"
          @updateNotes="(e) => (state.user_comment = e)"
        />
      </transition>
    </template>
  </Modal>
</template>

<script setup>
import { reactive, watch } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import { useParticipantStore } from "@/stores/participant.js";
import { getDate } from "@/composables/utils.js";
import { getError } from "@/composables/error.js";
import { useToast } from "vue-toastification";
import StatusTab from "./tabs/Status.vue";
import NotesTab from "./tabs/Notes.vue";

const tabsContent = [NotesTab, StatusTab];

const route = useRoute();

const toast = useToast();

const participantStore = useParticipantStore();
const { currentParticipant } = storeToRefs(participantStore);

const state = reactive({
  currentTab: 0,
  user_comment: null,
});

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
});

const emits = defineEmits(["close"]);

async function saveNote() {
  const resp = await participantStore.commentParticipant(
    route.params.companyId,
    route.params.spaceId,
    route.params.campaignId,
    currentParticipant.value.participant_id,
    state.user_comment
  );

  if (!resp.code) {
    toast.success("Informations sauvegardées avec succès.");
    close();
    currentParticipant.value.user_comment = state.user_comment;
  } else {
    toast.error(getError(resp.key));
  }
}

function close() {
  state.currentTab = 0;
  emits("close");
}

watch(
  () => props.isOpen,
  () => {
    state.user_comment = currentParticipant.value.user_comment;
  }
);
</script>
